import React from 'react';
import videojs from 'video.js';

import './videoJsStyles.css';                                                                                                                                          

export default class VideoPlayer extends React.Component {

  constructor() {
    super();

    this.state = { 
      isPlaying: false,
      currentTab: 0,
      started: false,
    };

    this.handleTabsChange = this.handleTabsChange.bind(this);
  }

  componentDidMount() {
    // instantiate video.js
    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {});

    window.addEventListener("changedTab", (event) => {
      this.handleTabsChange(event.tabIndex);
    });
    window.addEventListener("tabUpdate", (event) => {
      this.handleTabsChange(event.tabIndex);
    });
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();

      window.removeEventListener("changedTab", () => {});
      window.removeEventListener("tabUpdate", () => {});
    }
  }

  handleTabsChange(tab) {
    if(this.state.currentTab === 0) {
      this.setState({started: this.state.isPlaying});
    }

      if(tab === 0 && this.state.started) {
          // start playing if player was playing befor tab change
          this.player.play();
      } else {
          // pause if player is playing
          this.player.pause();
      }
      
      this.setState({currentTab: tab});
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    return (
        <>
          <link
            href="https://unpkg.com/@videojs/themes@1/dist/forest/index.css"
            rel="stylesheet"
          />
          <div id="vjs-player-div" data-vjs-player style={{ height: "100%", width: "100%", borderRadius: "2vw", overflow: "hidden" }}>
              <video
                ref={node => (this.videoNode = node)}
                className='video-js vjs-theme-forest'
                playsInline
                style={{ height: "100%", width: "100%", borderRadius: "2vw", overflow: "hidden"}}
                onPlay={() => {this.setState({ isPlaying: true })}}
                onPause={() => {this.setState({ isPlaying: false })}}
              />
          </div>
        </>
    );
  }
}